/**
 * Checks if an event is supported in the current execution environment.
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
export function isCoveredByReact(eventNameSuffix) {
  var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in doc;

  if (!isSupported) {
    var element = doc.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  return isSupported;
}
export function syncEvent(node, eventName, newEventHandler) {
  var eventStore = node.__events || (node.__events = {});
  var oldEventHandler = eventStore[eventName]; // Remove old listener so they don't double up.

  if (oldEventHandler) {
    node.removeEventListener(eventName, oldEventHandler);
  } // Bind new listener.


  node.addEventListener(eventName, eventStore[eventName] = function handler(e) {
    newEventHandler.call(this, e);
  });
}
export var dashToPascalCase = function dashToPascalCase(str) {
  return str.toLowerCase().split('-').map(function (segment) {
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  }).join('');
};
export function ensureElementInBody(elementName) {
  var element = document.querySelector(elementName);

  if (!element) {
    element = document.createElement(elementName);
    document.body.appendChild(element);
  }

  return element;
}
export function attachEventProps(node, props) {
  Object.keys(props).forEach(function (name) {
    if (name === 'children' || name === 'style' || name === 'ref') {
      return;
    }

    if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
      var eventName = name.substring(2);
      var eventNameLc = eventName[0].toLowerCase() + eventName.substring(1);

      if (!isCoveredByReact(eventNameLc)) {
        syncEvent(node, eventNameLc, props[name]);
      }
    } else {
      node[name] = props[name];
    }
  });
}
export function generateUniqueId() {
  return ([1e7].toString() + -1e3.toString() + -4e3.toString() + -8e3.toString() + -1e11.toString()).replace(/[018]/g, function (c) {
    var random = crypto.getRandomValues(new Uint8Array(1));
    return (c ^ random[0] & 15 >> c / 4).toString(16);
  });
}